module.exports = __webpack_public_path__ + "img/ast03.5d9ad0d5.svg";